// src/contexts/LanguageContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const translations = {
  ar: {
    appName: "AT Delivery",
    home: "الرئيسية",
    login: "تسجيل الدخول",
    logout: "تسجيل الخروج",
    register: "إنشاء حساب جديد",
    dashboard: "لوحة التحكم",
    orders: "الطلبات",
    newOrder: "طلب جديد",
    settings: "الإعدادات",
    reports: "التقارير",
    wallet: "المحفظة",
    notifications: "الإشعارات",
    welcome: "مرحباً بك",
    loading: "جاري التحميل...",
    homepage_desc: "أفضل منصة لإدارة وتوصيل الطلبات للمطاعم والسائقين والعملاء",
    privacy_policy: "سياسة الخصوصية",
    terms_of_service: "الشروط والأحكام",
    return_policy: "سياسة الاسترجاع",
    pricing: "الأسعار",
    about_us: "من نحن",
    contact_us: "اتصل بنا",
    faq: "الأسئلة الشائعة",
    faq_description: "لقد جمعنا الأسئلة الأكثر شيوعًا عن خدماتنا. إذا لم تجد إجابة لسؤالك، يرجى التواصل مع فريق الدعم.",
    driver_faq_section: "أسئلة السائقين",
    restaurant_faq_section: "أسئلة المطاعم",
    general_faq_section: "أسئلة عامة",
    faq_not_found: "لم تجد ما تبحث عنه؟",
    contact_support: "تواصل مع فريق الدعم على info@atdelivery.net",
    user_guide: "دليل المستخدم",
    features: "مميزات التطبيق",
    features_description: "اكتشف المميزات الرائعة التي تجعل ATDelivery الخيار الأمثل لتوصيل الطعام",
    restaurant_features_title: "مميزات المطاعم",
    restaurant_features_description: "إدارة قائمة الطعام بسهولة، متابعة الطلبات في الوقت الحقيقي، وتقارير تفصيلية لأداء المطعم",
    driver_features_title: "مميزات السائقين",
    driver_features_description: "تتبع الطلبات في الوقت الحقيقي، خريطة ذكية للمسارات، وتقارير الأداء اليومية",
    customer_features_title: "مميزات العملاء",
    customer_features_description: "تتبع الطلبات مباشرة، تقييم المطاعم والسائقين، ودفع آمن وسريع",
    speed_features_title: "سرعة التوصيل",
    speed_features_description: "توصيل سريع وفعال مع خوارزميات ذكية لاختيار أفضل المسارات",
    security_features_title: "الأمان والخصوصية",
    security_features_description: "حماية بياناتك الشخصية وضمان معاملات آمنة مع أحدث تقنيات التشفير",
    support_features_title: "دعم العملاء",
    support_features_description: "دعم فني متواصل على مدار الساعة مع فريق متخصص لحل جميع استفساراتك",
    delete_account: "حذف الحساب",
    all_rights_reserved: "جميع الحقوق محفوظة © AT Delivery 2025",

    restaurant: "المطعم",
    restaurantDashboard: "لوحة تحكم المطعم",
    totalOrders: "إجمالي الطلبات",
    completedOrders: "الطلبات المكتملة",
    pendingOrders: "الطلبات قيد التنفيذ",
    cancelledOrders: "الطلبات الملغاة",
    todayOrders: "طلبات اليوم",
    currentBalance: "رصيدك الحالي",

    orderNumber: "رقم الطلب",
    customerName: "اسم العميل",
    customerPhone: "رقم الهاتف",
    customerAddress: "العنوان",
    orderStatus: "حالة الطلب",
    orderAmount: "المبلغ",
    createdAt: "تاريخ الطلب",
    payment_Method: "طريقة الدفع",
    paymentmethod: "طريقة الدفع",
    cancelOrder: "إلغاء الطلب",

    reports_statistics: "التقارير والإحصائيات",
    time_period: "الفترة الزمنية",
    today: "اليوم",
    last_week: "آخر أسبوع",
    last_month: "آخر شهر",
    last_year: "آخر سنة",
    orders_report: "تقرير الطلبات",
    financial_report: "التقرير المالي",
    total_orders: "إجمالي الطلبات",
    completed_orders: "الطلبات المكتملة",
    cancelled_orders: "الطلبات الملغاة",
    completion_rate: "نسبة إكمال الطلبات",
    total_sales: "إجمالي المبيعات",
    delivery_fees: "رسوم التوصيل",
    avg_order_value: "متوسط قيمة الطلب",
    net_sales: "صافي المبيعات",
    orders_over_time: "الطلبات عبر الزمن",
    revenue_over_time: "الإيرادات عبر الزمن",
    payment_methods: "طرق الدفع",
    order_statuses: "حالات الطلبات",
    orders_details: "تفاصيل الطلبات",
    financial_transactions: "المعاملات المالية",
    no_orders_in_period: "لا توجد طلبات في الفترة المحددة",
    no_transactions_in_period: "لا توجد معاملات مالية في الفترة المحددة",
    order: "طلب",
    revenue: "الإيرادات",
    quantity: "الكمية",
    date: "التاريخ",
    customer: "العميل",
    amount: "المبلغ",
    status: "الحالة",
    description: "الوصف",
    type: "النوع",
    deposit: "إيداع",
    deduction: "خصم",
    currency: "د.ك",

    statusPending: "قيد التنفيذ 🚀",
    statusOnWay: "تم الاستلام 🚗",
    statusDelivered: "تم التسليم ✅",
    statusCancelled: "ملغي ❌",

    save: "حفظ",
    cancel: "إلغاء",
    confirm: "تأكيد",
    search: "بحث",
    view: "عرض",
    edit: "تعديل",
    delete: "حذف",
    update: "تحديث",

    map_load_error: "تعذر تحميل خرائط Google. بعض الوظائف قد لا تعمل.",
    map_loading: "جاري تحميل الخرائط... يرجى الانتظار.",
    select_role: "الرجاء اختيار الدور",
    verify_email_warning: "يرجى تأكيد بريدك الإلكتروني أولاً قبل تسجيل الدخول.",
    admin_not_registered: "هذا الحساب غير مسجل كمسئول.",
    restaurant_not_registered: "هذا الحساب غير مسجل كمطعم.",
    driver_not_registered: "هذا الحساب غير مسجل كسائق.",
    select_correct_role: "برجاء اختيار دورك الصحيح أو مراجعة الإدارة.",
    login_error: "خطأ في تسجيل الدخول. تحقق من البريد وكلمة المرور.",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    admin: "مسؤول",
    driver: "سائق",

    error: "حدث خطأ",
    tryAgain: "حاول مرة أخرى",
    order_details: "تفاصيل الطلب",
    order_date: "تاريخ الطلب",
    customer_info: "معلومات العميل",
    order_items: "العناصر",
    subtotal: "الإجمالي الفرعي",
    delivery_fee: "رسوم التوصيل",
    total: "الإجمالي الكلي",
    delivery_info: "معلومات التوصيل",
    payment_method: "طريقة الدفع",
    payment_status: "حالة الدفع",
    paid: "مدفوع",
    unpaid: "غير مدفوع",
    track_driver: "تتبع السائق",
    hide_driver_tracking: "إخفاء التتبع",
    cancel_order: "إلغاء الطلب",
    order_cancelled_success: "تم إلغاء الطلب بنجاح",
    error_cancelling_order: "حدث خطأ أثناء إلغاء الطلب",
    order_not_found: "الطلب غير موجود",
    error_loading_order: "حدث خطأ أثناء تحميل الطلب",
    restaurant_dashboard_title: "لوحة تحكم المطعم",
    loadingData: "جاري تحميل البيانات...",
    welcome_message: "أهلاً بك",
    dashboardDescription: "هذه هي لوحة التحكم الخاصة بمطعمك. يمكنك إدارة طلباتك وتتبع أدائك هنا.",
    restaurant_stats: "إحصائيات المطعم",
    pending_orders: "الطلبات قيد التنفيذ",
    today_orders: "طلبات اليوم",
    walletBalance: "رصيد المحفظة",
    currency_kwd: "د.ك",
    rechargeBalance: "شحن الرصيد",
    sendNewOrder: "إرسال طلب جديد",
    sendOrderDescription: "أرسل طلباتك للسائقين لتوصيلها للعملاء",
    manageOrders: "إدارة الطلبات",
    manageOrdersDescription: "عرض وإدارة جميع طلباتك",
    view_reports: "التقارير",
    reportsDescription: "عرض تقارير المبيعات والإحصائيات",
    view_wallet: "المحفظة",
    walletDescription: "إدارة رصيدك وعرض المعاملات المالية",
    switchLanguage: "Switch to English",
    currentLanguage: "العربية",
    admin_restaurant_management: "إدارة المطاعم",
    admin_driver_management: "إدارة السائقين",
    admin_driver_tracking: "تتبع السائقين",
    admin_driver_tracking_reports: "تقارير تتبع السائقين",
    admin_chat: "الدردشة",
    admin_database: "قاعدة البيانات",
    admin_tools: "أدوات النظام",
    admin_dashboard_title: "لوحة تحكم المدير",
    admin_dashboard_welcome: "مرحباً بك في لوحة تحكم ATDelivery",
    admin_dashboard_desc: "إدارة المطاعم والسائقين والطلبات بكل سهولة",
    admin_dashboard_restaurants: "المطاعم",
    admin_dashboard_drivers: "السائقين",
    admin_dashboard_completed_orders: "الطلبات المكتملة",
    admin_dashboard_add_edit_restaurants: "إضافة وتعديل المطاعم",
    admin_dashboard_add_track_drivers: "إضافة وتتبع السائقين",
    admin_dashboard_view_all_orders: "عرض جميع الطلبات",
    admin_dashboard_view_reports: "عرض التقارير",
    admin_dashboard_manage_data: "إدارة قاعدة البيانات",
    admin_dashboard_view_drivers_location: "عرض مواقع السائقين",
    admin_dashboard_view_drivers_reports: "عرض تقارير السائقين",
    admin_dashboard_send_edit_notifications: "إرسال وتعديل الإشعارات",
    status_completed: "مكتمل",
    order_completed: "الطلبات المكتملة",

    // Driver FAQ Questions
    driver_faq_1_question: "كيف يمكنني التسجيل كسائق توصيل؟",
    driver_faq_1_answer: "يمكنك التسجيل كسائق من خلال تنزيل التطبيق وإنشاء حساب جديد، ثم تقديم المستندات المطلوبة (صورة من رخصة القيادة، تأمين المركبة، إثبات الهوية). بعد التحقق من معلوماتك، سيتم تفعيل حسابك في غضون 24-48 ساعة.",
    driver_faq_2_question: "كيف أتلقى طلبات التوصيل؟",
    driver_faq_2_answer: "بعد تسجيل الدخول إلى التطبيق وتغيير حالتك إلى \"متاح\"، ستبدأ في تلقي إشعارات بطلبات التوصيل القريبة منك. يمكنك قبول الطلب أو رفضه خلال الوقت المحدد.",
    driver_faq_3_question: "كيف يتم احتساب رسوم التوصيل؟",
    driver_faq_3_answer: "يتم احتساب رسوم التوصيل بناءً على عدة عوامل منها المسافة بين المطعم والعميل، ووقت الذروة، وحجم الطلب. يمكنك رؤية رسوم التوصيل قبل قبول الطلب.",
    driver_faq_4_question: "متى سأحصل على مستحقاتي المالية؟",
    driver_faq_4_answer: "يتم تسوية المدفوعات أسبوعياً، ويتم إيداع المبالغ في حسابك البنكي المسجل. يمكنك مراقبة أرباحك ومستحقاتك في قسم \"المحفظة\" في التطبيق.",
    driver_faq_5_question: "ماذا أفعل إذا واجهت مشكلة أثناء التوصيل؟",
    driver_faq_5_answer: "في حالة حدوث أي مشكلة، يمكنك استخدام خاصية \"الدردشة الطارئة\" في التطبيق للتواصل المباشر مع فريق الدعم. كما يمكنك أيضًا الاتصال برقم الدعم المخصص للسائقين للحصول على المساعدة الفورية.",
    driver_faq_6_question: "هل يمكنني العمل بدوام جزئي كسائق توصيل؟",
    driver_faq_6_answer: "نعم، يمكنك العمل بالساعات التي تناسبك. ما عليك سوى تسجيل الدخول إلى التطبيق عندما تكون متاحًا وتغيير حالتك إلى \"متاح\".",
    driver_faq_7_question: "كيف يمكنني تحسين تقييمي في التطبيق؟",
    driver_faq_7_answer: "يمكنك تحسين تقييمك من خلال التوصيل في الوقت المحدد، والحفاظ على نظافة وسلامة الطلبات، والتعامل المهذب مع العملاء. كلما ارتفع تقييمك، زادت فرصك في الحصول على طلبات أكثر.",
    driver_faq_8_question: "هل يمكنني رفض طلبات معينة؟",
    driver_faq_8_answer: "نعم، يمكنك اختيار الطلبات التي ترغب في قبولها. ومع ذلك، قد يؤثر معدل الرفض المرتفع على تقييمك العام وفرصك في الحصول على طلبات مستقبلية.",

    // Restaurant FAQ Questions
    restaurant_faq_1_question: "كيف يمكنني تسجيل مطعمي في النظام؟",
    restaurant_faq_1_answer: "يمكنك التسجيل بسهولة عبر موقعنا الإلكتروني من خلال نموذج التسجيل. سيتصل بك فريقنا خلال 24 ساعة لتأكيد المعلومات وإكمال عملية التسجيل.",
    restaurant_faq_2_question: "ما هي العمولة التي تأخذها المنصة؟",
    restaurant_faq_2_answer: "تعتمد العمولة على خطة الاشتراك التي تختارها. نقدم خططًا مختلفة تبدأ من 10% إلى 20% من قيمة الطلب، مع وجود خيارات للمطاعم ذات الحجم الكبير والسلاسل.",
    restaurant_faq_3_question: "كيف يمكنني إدارة قائمة الطعام؟",
    restaurant_faq_3_answer: "يمكنك إدارة قائمة الطعام بسهولة من خلال لوحة تحكم المطعم. بإمكانك إضافة أو تعديل أو إزالة العناصر، وتعديل الأسعار، وإضافة خيارات وإضافات خاصة لكل عنصر.",
    restaurant_faq_4_question: "هل يمكنني رفض طلبات معينة؟",
    restaurant_faq_4_answer: "نعم، يمكنك قبول أو رفض الطلبات وفقًا لظروف مطعمك. ومع ذلك، نشجع على الحفاظ على معدل قبول مرتفع لتحسين تصنيف مطعمك في التطبيق.",

    // General FAQ Questions
    general_faq_1_question: "هل التطبيق متاح في مدينتي؟",
    general_faq_1_answer: "نحن حاليًا نعمل في المدن الرئيسية في الكويت ودول الخليج، ونتوسع باستمرار. يمكنك التحقق من توفر الخدمة في منطقتك عبر التطبيق أو موقعنا الإلكتروني.",
    general_faq_2_question: "كيف يمكنني التواصل مع دعم العملاء؟",
    general_faq_2_answer: "يمكنك التواصل مع فريق دعم العملاء عبر الدردشة المباشرة في التطبيق، أو عبر البريد الإلكتروني info@atdelivery.net، أو الاتصال برقم الدعم المباشر.",
    general_faq_3_question: "هل يمكنني استخدام التطبيق بلغات مختلفة؟",
    general_faq_3_answer: "نعم، التطبيق متاح حاليًا باللغتين العربية والإنجليزية. يمكنك تغيير اللغة من خلال إعدادات التطبيق.",
    general_faq_4_question: "هل تقدمون خدمات توصيل لأماكن أخرى غير المطاعم؟",
    general_faq_4_answer: "حاليًا، نحن متخصصون في توصيل الطعام من المطاعم. قريبًا سنطلق خدمات توصيل البقالة والمستلزمات الأساسية.",

    // About Us Translations
    our_mission: "مهمتنا",
    mission_description: "نحن نسعى لتقديم أفضل خدمة توصيل طعام في الكويت، من خلال ربط المطاعم والسائقين والعملاء بطريقة ذكية وسلسة. هدفنا هو تحسين تجربة الطلب والتوصيل، وزيادة كفاءة العمليات اليومية للمطاعم والسائقين.",
    our_vision: "رؤيتنا",
    vision_description: "نسعى لأن نكون المنصة الرائدة في توصيل الطعام في الكويت والخليج، من خلال تقديم خدمات متميزة وتجربة مستخدم فريدة، مع الحفاظ على أعلى معايير الجودة والكفاءة.",
    our_values: "قيمنا",
    value_quality: "الجودة",
    value_quality_description: "نلتزم بتقديم خدمات عالية الجودة لجميع عملائنا، من المطاعم والسائقين والعملاء.",
    value_innovation: "الابتكار",
    value_innovation_description: "نعمل باستمرار على تطوير وتحسين خدماتنا باستخدام أحدث التقنيات والحلول المبتكرة.",
    value_customer: "رضا العملاء",
    value_customer_description: "نضع رضا عملائنا في مقدمة أولوياتنا، ونسعى لتقديم تجربة متميزة تلبي توقعاتهم.",

    // Contact Us Translations
    contact_form: "نموذج الاتصال",
    contact_info: "معلومات الاتصال",
    send_message: "إرسال الرسالة",
    name: "الاسم",
    subject: "الموضوع",
    message: "الرسالة",
    address: "برج ATDelivery، شارع سالم المبارك، السالمية، الكويت",
    phone: "+965 5555 5555",
    contact_email: "info@atdelivery.net",
    working_hours: "ساعات العمل",
    working_hours_description: "نحن متاحون من الساعة 9 صباحًا حتى 10 مساءً، 7 أيام في الأسبوع",
    social_media: "وسائل التواصل الاجتماعي",
    driver_support: "دعم السائقين",
    driver_hotline: "+965 5555 1111",
    driver_email: "drivers@atdelivery.net",
    emergency_chat_notice: "للمساعدة العاجلة، يرجى استخدام خاصية \"الدردشة الطارئة\" داخل التطبيق",
    fill_all_fields: 'يرجى ملء جميع الحقول المطلوبة',
    restaurant_id: 'معرف المطعم',
    customer_name: 'اسم العميل',
    customer_phone: 'رقم هاتف العميل',
    customer_address: 'عنوان العميل',
    order_amount: 'المبلغ',
    cash: 'نقدي',
    knet: 'كي نت',
    card: 'بطاقة',
    add_order: 'إضافة طلب',
    order_number: 'رقم الطلب',
    actions: 'الإجراءات',
    status_pending: 'قيد الانتظار',
    status_on_way: 'في الطريق',
    status_delivered: 'تم التسليم',
    status_cancelled: 'ملغي',
    restaurant_management: 'إدارة المطاعم',
    add_new_restaurant: 'إضافة مطعم جديد',
    restaurant_name: 'اسم المطعم',
    restaurant_email: 'البريد الإلكتروني',
    restaurant_phone: 'رقم الهاتف',
    restaurant_password: 'كلمة المرور',
    restaurant_area: 'المنطقة',
    restaurant_status: 'الحالة',
    restaurant_balance: 'الرصيد',
    restaurants_list: 'قائمة المطاعم',
    add_restaurant: 'إضافة مطعم',
    fill_required_fields: 'يرجى ملء جميع الحقول المطلوبة',
    restaurant_added_success: 'تم إضافة المطعم بنجاح',
    error_adding_restaurant: 'حدث خطأ أثناء إضافة المطعم',
    status_active: 'نشط',
    status_inactive: 'غير نشط',
    area_capital: 'العاصمة',
    area_hawally: 'حولي',
    area_farwaniya: 'الفروانية',
    area_ahmadi: 'الأحمدي',
    area_mubarak: 'مبارك الكبير',
    area_jahra: 'الجهراء',

    // Restaurant Management Translations
    restaurant_management_title: "إدارة المطاعم",
    restaurant_management_map: "الخريطة",
    restaurant_management_add: "إضافة مطعم",
    restaurant_management_stats: "إحصائيات المطاعم",
    restaurant_management_total: "إجمالي المطاعم",
    restaurant_management_active: "مطاعم نشطة",
    restaurant_management_total_balance: "إجمالي الرصيد",
    restaurant_management_no_restaurants: "لا يوجد مطاعم متاحة حالياً",
    restaurant_management_name: "الاسم",
    restaurant_management_phone: "الهاتف",
    restaurant_management_status: "الحالة",
    restaurant_management_area: "المنطقة",
    restaurant_management_balance: "الرصيد",
    restaurant_management_actions: "الإجراءات",
    restaurant_management_edit: "تعديل",
    restaurant_management_save: "حفظ",
    restaurant_management_charge: "شحن 10 د.ك",
    restaurant_management_toggle: "تفعيل/إيقاف",
    restaurant_management_delete: "حذف",
    restaurant_management_add_new: "إضافة مطعم جديد",
    restaurant_management_restaurant_name: "اسم المطعم",
    restaurant_management_email: "البريد الإلكتروني",
    restaurant_management_phone_number: "رقم الهاتف",
    restaurant_management_password: "كلمة المرور",
    restaurant_management_initial_balance: "الرصيد الابتدائي",
    restaurant_management_address: "العنوان",
    restaurant_management_selected_address: "العنوان المختار",
    restaurant_management_map_location: "موقع المطعم على الخريطة",
    restaurant_management_search_placeholder: "ابحث عن العنوان في الكويت",
    restaurant_management_searching: "جاري البحث...",
    restaurant_management_confirm_delete: "هل أنت متأكد أنك تريد حذف هذا المطعم؟",
    restaurant_management_delete_success: "تم حذف المطعم بنجاح",
    restaurant_management_delete_error: "حدث خطأ أثناء حذف المطعم",
    restaurant_management_balance_error: "لا يمكن أن يكون الرصيد بقيمة سالبة",
    restaurant_management_balance_success: "تم تحديث الرصيد بنجاح",
    restaurant_management_balance_update_error: "حدث خطأ أثناء تحديث الرصيد",
    restaurant_management_status_success: "تم تحديث حالة المطعم بنجاح",
    restaurant_management_status_error: "حدث خطأ أثناء تحديث حالة المطعم",
    restaurant_management_map_error: "خطأ في تحميل الخريطة",
    restaurant_management_map_loading: "جاري تحميل الخريطة...",

    // Orders Page Translations
    orders_title: "الطلبات",
    orders_new: "طلب جديد",
    orders_restaurant_id: "معرف المطعم",
    orders_customer_name: "اسم العميل",
    orders_customer_phone: "رقم هاتف العميل",
    orders_customer_address: "عنوان العميل",
    orders_amount: "المبلغ",
    orders_payment_method: "طريقة الدفع",
    orders_add: "إضافة طلب",
    orders_number: "رقم الطلب",
    orders_status: "الحالة",
    orders_actions: "الإجراءات",
    orders_pending: "قيد الانتظار",
    orders_on_way: "في الطريق",
    orders_delivered: "تم التسليم",
    orders_cancelled: "ملغي",
    orders_cash: "نقدي",
    orders_knet: "كي نت",
    orders_card: "بطاقة",
    orders_fill_fields: "يرجى ملء جميع الحقول المطلوبة",
    orders_add_success: "تم إضافة الطلب بنجاح",
    orders_add_error: "حدث خطأ أثناء إضافة الطلب",
    orders_update_success: "تم تحديث حالة الطلب بنجاح",
    orders_update_error: "حدث خطأ أثناء تحديث حالة الطلب",
    orders_db_status: "حالة الاتصال بقاعدة البيانات",
    orders_db_connected: "متصل بقاعدة البيانات",
    orders_db_checking: "جاري التحقق...",
    orders_db_error: "فشل الاتصال بقاعدة البيانات",
    orders_loading: "جاري تحميل الطلبات...",
    orders_no_orders: "لا توجد طلبات متاحة",
    orders_fetch_error: "خطأ في جلب الطلبات",

    // Driver Tracking Reports Translations
    driver_tracking_reports: "تقارير متابعة السائقين",
    activity_report: "تقرير النشاط",
    movements_report: "تقرير التحركات",
    availability_report: "تقرير الجاهزية",
    activity_app_open: "فتح التطبيق",
    activity_app_close: "إغلاق التطبيق",
    activity_available_toggle: "تغيير الجاهزية",
    activity_order_received: "استلام طلب",
    activity_order_completed: "إكمال طلب",
    activity_login: "تسجيل الدخول",
    activity_logout: "تسجيل الخروج",
    activity_navigate_to_restaurant: "التوجه إلى المطعم",
    activity_navigate_to_customer: "التوجه إلى العميل",
    activity_order_status_change: "تغيير حالة الطلب",
    export_excel: "استخراج Excel",
    export_pdf: "استخراج PDF",
    report_type: "نوع التقرير",
    date_range: "الفترة الزمنية",
    all_drivers: "جميع السائقين",
    page_size: "عدد العناصر بالصفحة",
    total_drivers: "إجمالي السائقين",
    active_drivers: "السائقين النشطين",
    average_active_time: "متوسط وقت النشاط",
    average_speed: "متوسط السرعة",
    total_available_time: "إجمالي وقت الجاهزية",
    km_per_hour: "كم/س",
    hours: "ساعة",
    app_open: "فتح التطبيق",
    available: "متاح للعمل",
    available_time: "وقت الجاهزية",
    unavailable_time: "وقت عدم الجاهزية",
    max_speed: "أقصى سرعة (كم/س)",
    activity_details: "تفاصيل نشاط السائقين",
    movements_details: "تفاصيل تحركات السائقين",
    availability_details: "تفاصيل جاهزية السائقين",
    time: "الوقت",
    activity_type: "نوع النشاط",
    value: "القيمة",
    no_data_for_period_or_filter: "لا توجد بيانات للفترة أو الفلتر المحدد",
    yes: "نعم",
    no: "لا",
    loading_more_data: "جاري تحميل المزيد من البيانات...",
    load_more_data: "تحميل المزيد من البيانات",
    all_data_displayed: "تم عرض جميع البيانات المتاحة",
    location: "الموقع (خط العرض/الطول)",
    speed: "السرعة (كم/س)",
    destination: "الوجهة",
    no_data_for_period: "لا توجد بيانات للفترة المحددة",
    not_available: "غير متوفر",
    notes: "ملاحظات",
    all_statuses: "جميع الحالات",
    orders_management: "إدارة الطلبات",
    orders_list: "قائمة الطلبات",
    orders_map: "خريطة الطلبات",
    all_restaurants: "جميع المطاعم",
    table: "جدول",
    cards: "بطاقات",
    details: "تفاصيل",
    track: "تتبع",
    delete_selected_orders: "حذف الطلبات المحددة",
    delete_confirmation: "تأكيد الحذف",
    confirm_delete_message: "هل أنت متأكد من حذف الطلبات المحددة؟",
    permanent_delete_warning: "تحذير: سيتم حذف الطلبات نهائياً من قاعدة البيانات وبيانات المطعم!",
    confirm_delete: "تأكيد الحذف",
    no_orders_found: "لا توجد طلبات مطابقة للفلاتر المحددة",
    delivered: "تم التسليم",
    picked_up: "تم الاستلام",
    pending: "معلق",
    loading_map: "جاري تحميل الخريطة...",
    restaurant_and_delivery: "معلومات المطعم والتوصيل",
    unknown_restaurant: "غير معروف",
    no_driver_assigned: "لم يتم تعيين سائق",
    unknown_amount: "غير معروف",
    unknown_delivery_fee: "غير معروف",
    delete_order: "حذف الطلب",
    order_search_placeholder: "رقم الطلب، اسم العميل، رقم الهاتف",
    chat_messages: "رسائل الشات",
    mark_all_as_read: "تعليم الكل كمقروء",
    mark_as_read: "تعليم كمقروء",
    no_notifications: "لا توجد إشعارات",
    in_this_category: "في هذه الفئة",
    all: "الكل",
    unread: "غير مقروءة",
    read: "مقروءة",
    average_delivery_time: "متوسط وقت التوصيل",
    orders_completed: "الطلبات المكتملة",
    total_revenue: "إجمالي الإيرادات",
    total_restaurants: "إجمالي المطاعم",
    average_order_value:  "متوسط قيمة الطلب",
  },
  en: {
    appName: "AT Delivery",
    home: "Home",
    login: "Login",
    logout: "Logout",
    register: "Register",
    dashboard: "Dashboard",
    orders: "Orders",
    newOrder: "New Order",
    settings: "Settings",
    reports: "Reports",
    wallet: "Wallet",
    notifications: "Notifications",
    welcome: "Welcome",
    loading: "Loading...",
    homepage_desc: "The best platform for managing and delivering orders for restaurants, drivers, and customers.",
    privacy_policy: "Privacy Policy",
    terms_of_service: "Terms of Service",
    return_policy: "Return Policy",
    pricing: "Pricing",
    about_us: "About Us",
    contact_us: "Contact Us",
    faq: "Frequently Asked Questions",
    faq_description: "We have compiled the most frequently asked questions about our services. If you don't find the answer to your question, please contact our support team.",
    driver_faq_section: "Driver Questions",
    restaurant_faq_section: "Restaurant Questions",
    general_faq_section: "General Questions",
    faq_not_found: "Didn't find what you're looking for?",
    contact_support: "Contact our support team at info@atdelivery.net",
    user_guide: "User Guide",
    features: "App Features",
    features_description: "Discover the amazing features that make ATDelivery the best choice for food delivery",
    restaurant_features_title: "Restaurant Features",
    restaurant_features_description: "Easy menu management, real-time order tracking, and detailed performance reports",
    driver_features_title: "Driver Features",
    driver_features_description: "Real-time order tracking, smart route mapping, and daily performance reports",
    customer_features_title: "Customer Features",
    customer_features_description: "Live order tracking, restaurant and driver ratings, and secure fast payments",
    speed_features_title: "Fast Delivery",
    speed_features_description: "Quick and efficient delivery with smart algorithms for optimal route selection",
    security_features_title: "Security & Privacy",
    security_features_description: "Protect your personal data and ensure secure transactions with latest encryption",
    support_features_title: "Customer Support",
    support_features_description: "24/7 technical support with a dedicated team to answer all your queries",
    delete_account: "Delete Account",
    all_rights_reserved: "All rights reserved © AT Delivery 2025",

    restaurant: "Restaurant",
    restaurantDashboard: "Restaurant Dashboard",
    totalOrders: "Total Orders",
    completedOrders: "Completed Orders",
    pendingOrders: "Pending Orders",
    cancelledOrders: "Cancelled Orders",
    todayOrders: "Today's Orders",
    currentBalance: "Current Balance",

    orderNumber: "Order #",
    customerName: "Customer Name",
    customerPhone: "Phone",
    customerAddress: "Address",
    orderStatus: "Status",
    orderAmount: "Amount",
    createdAt: "Created At",
    paymentMethod: "Payment Method",
    payment_Method: "Payment Method",
    cancelOrder: "Cancel Order",

    reports_statistics: "Reports & Statistics",
    time_period: "Time Period",
    today: "Today",
    last_week: "Last Week",
    last_month: "Last Month",
    last_year: "Last Year",
    orders_report: "Orders Report",
    financial_report: "Financial Report",
    total_orders: "Total Orders",
    completed_orders: "Completed Orders",
    cancelled_orders: "Cancelled Orders",
    completion_rate: "Completion Rate",
    total_sales: "Total Sales",
    delivery_fees: "Delivery Fees",
    avg_order_value: "Average Order Value",
    net_sales: "Net Sales",
    orders_over_time: "Orders Over Time",
    revenue_over_time: "Revenue Over Time",
    payment_methods: "Payment Methods",
    order_statuses: "Order Statuses",
    orders_details: "Orders Details",
    financial_transactions: "Financial Transactions",
    no_orders_in_period: "No orders in the selected period",
    no_transactions_in_period: "No transactions in the selected period",
    order: "Order",
    revenue: "Revenue",
    quantity: "Quantity",
    date: "Date",
    customer: "Customer",
    amount: "Amount",
    status: "Status",
    description: "Description",
    type: "Type",
    deposit: "Deposit",
    deduction: "Deduction",
    currency: "KWD",

    statusPending: "Pending 🚀",
    statusOnWay: "On the Way 🚗",
    statusDelivered: "Delivered ✅",
    statusCancelled: "Cancelled ❌",
    orders_completed: "Orders Completed",
    total_revenue: "Total Revenue",
    total_restaurants:  "Total Restaurants",
    average_order_value:  "Average Order Value",

    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    search: "Search",
    view: "View",
    edit: "Edit",
    delete: "Delete",
    update: "Update",

    map_load_error: "Google Maps failed to load. Some functions may not work.",
    map_loading: "Loading Google Maps... please wait.",
    select_role: "Please select your role",
    verify_email_warning: "Please verify your email before logging in.",
    admin_not_registered: "This account is not registered as admin.",
    restaurant_not_registered: "This account is not registered as restaurant.",
    driver_not_registered: "This account is not registered as driver.",
    select_correct_role: "Please select your correct role or contact administration.",
    login_error: "Login error. Please check your email and password.",
    email: "Email",
    password: "Password",
    admin: "Admin",
    driver: "Driver",
    error: "An error occurred",
    tryAgain: "Try again",
    order_details: "Order Details",
    order_date: "Order Date",
    customer_info: "Customer Info",
    order_items: "Items",
    subtotal: "Subtotal",
    delivery_fee: "Delivery Fee",
    total: "Total",
    delivery_info: "Delivery Info",
    payment_method: "Payment Method",
    payment_status: "Payment Status",
    paid: "Paid",
    unpaid: "Unpaid",
    track_driver: "Track Driver",
    hide_driver_tracking: "Hide Tracking",
    cancel_order: "Cancel Order",
    order_cancelled_success: "Order was successfully cancelled",
    error_cancelling_order: "An error occurred while cancelling the order",
    order_not_found: "Order not found",
    error_loading_order: "An error occurred while loading the order",
    restaurant_dashboard_title: "Restaurant Dashboard",
    loadingData: "Loading data...",
    welcome_message: "Welcome",
    dashboard_description: "This is your restaurant dashboard. You can manage your orders and track your performance here.",
    restaurant_stats: "Restaurant Statistics",
    pending_orders: "Pending Orders",
    today_orders: "Today's Orders",
    walletBalance: "Wallet Balance",
    currency_kwd: "KWD",
    rechargeBalance: "Recharge Balance",
    sendNewOrder: "Send New Order",
    sendOrderDescription: "Send your orders to drivers for delivery to customers",
    manageOrders: "Manage Orders",
    manageOrdersDescription: "View and manage all your orders",
    view_reports: "Reports",
    reportsDescription: "View sales reports and statistics",
    view_wallet: "Wallet",
    walletDescription: "Manage your balance and view financial transactions",
    switchLanguage: "تغيير إلى العربية",
    currentLanguage: "English",
    admin_restaurant_management: "Restaurant Management",
    admin_driver_management: "Driver Management",
    admin_driver_tracking: "Driver Tracking",
    admin_driver_tracking_reports: "Driver Tracking Reports",
    admin_chat: "Chat",
    admin_database: "Database",
    admin_tools: "System Tools",
    admin_dashboard_title: "Admin Dashboard",
    admin_dashboard_welcome: "Welcome to ATDelivery Admin Dashboard",
    admin_dashboard_desc: "Manage restaurants, drivers, and orders with ease",
    admin_dashboard_restaurants: "Restaurants",
    admin_dashboard_drivers: "Drivers",
    admin_dashboard_completed_orders: "Completed Orders",
    admin_dashboard_add_edit_restaurants: "Add and edit restaurants",
    admin_dashboard_add_track_drivers: "Add and track drivers",
    admin_dashboard_view_all_orders: "View all orders",
    admin_dashboard_view_reports: "View reports",
    admin_dashboard_manage_data: "Manage database",
    admin_dashboard_view_drivers_location: "View drivers locations",
    admin_dashboard_view_drivers_reports: "View drivers reports",
    admin_dashboard_send_edit_notifications: "Send and edit notifications",
    status_completed: "Completed",

    // Driver FAQ Questions
    driver_faq_1_question: "How do I register as a delivery driver?",
    driver_faq_1_answer: "You can register as a driver by downloading the app and creating a new account, then submitting the required documents (driver's license, vehicle insurance, ID). After verifying your information, your account will be activated within 24-48 hours.",
    driver_faq_2_question: "How do I receive delivery orders?",
    driver_faq_2_answer: "After logging into the app and changing your status to 'Available', you will start receiving notifications for delivery orders near you. You can accept or decline the order within the specified time.",
    driver_faq_3_question: "How are delivery fees calculated?",
    driver_faq_3_answer: "Delivery fees are calculated based on several factors including the distance between the restaurant and customer, peak times, and order size. You can see the delivery fee before accepting the order.",
    driver_faq_4_question: "When will I receive my payments?",
    driver_faq_4_answer: "Payments are settled weekly and deposited into your registered bank account. You can monitor your earnings and dues in the 'Wallet' section of the app.",
    driver_faq_5_question: "What should I do if I encounter a problem during delivery?",
    driver_faq_5_answer: "In case of any problem, you can use the 'Emergency Chat' feature in the app to directly communicate with the support team. You can also call the dedicated driver support number for immediate assistance.",
    driver_faq_6_question: "Can I work part-time as a delivery driver?",
    driver_faq_6_answer: "Yes, you can work hours that suit you. Simply log into the app when you're available and change your status to 'Available'.",
    driver_faq_7_question: "How can I improve my rating in the app?",
    driver_faq_7_answer: "You can improve your rating by delivering on time, maintaining the cleanliness and safety of orders, and being polite to customers. The higher your rating, the more likely you are to receive more orders.",
    driver_faq_8_question: "Can I decline certain orders?",
    driver_faq_8_answer: "Yes, you can choose which orders to accept. However, a high decline rate may affect your overall rating and your chances of receiving future orders.",

    // Restaurant FAQ Questions
    restaurant_faq_1_question: "How can I register my restaurant in the system?",
    restaurant_faq_1_answer: "You can easily register through our website using the registration form. Our team will contact you within 24 hours to confirm the information and complete the registration process.",
    restaurant_faq_2_question: "What commission does the platform take?",
    restaurant_faq_2_answer: "The commission depends on the subscription plan you choose. We offer different plans ranging from 10% to 20% of the order value, with options for large volume restaurants and chains.",
    restaurant_faq_3_question: "How can I manage my menu?",
    restaurant_faq_3_answer: "You can easily manage your menu through the restaurant dashboard. You can add, edit, or remove items, adjust prices, and add special options and add-ons for each item.",
    restaurant_faq_4_question: "Can I decline certain orders?",
    restaurant_faq_4_answer: "Yes, you can accept or decline orders according to your restaurant's circumstances. However, we encourage maintaining a high acceptance rate to improve your restaurant's ranking in the app.",

    // General FAQ Questions
    general_faq_1_question: "Is the app available in my city?",
    general_faq_1_answer: "We are currently operating in major cities in Kuwait and Gulf countries, and are continuously expanding. You can check the availability of the service in your area through the app or our website.",
    general_faq_2_question: "How can I contact customer support?",
    general_faq_2_answer: "You can contact our customer support team via live chat in the app, email at info@atdelivery.net, or call our direct support number.",
    general_faq_3_question: "Can I use the app in different languages?",
    general_faq_3_answer: "Yes, the app is currently available in Arabic and English. You can change the language through the app settings.",
    general_faq_4_question: "Do you offer delivery services for places other than restaurants?",
    general_faq_4_answer: "Currently, we specialize in food delivery from restaurants. Soon we will launch grocery and essential items delivery services.",

    // About Us Translations
    our_mission: "Our Mission",
    mission_description: "We strive to provide the best food delivery service in Kuwait by connecting restaurants, drivers, and customers in a smart and seamless way. Our goal is to improve ordering and delivery experiences while increasing daily efficiency for restaurants and drivers.",
    our_vision: "Our Vision",
    vision_description: "We aim to be the leading food delivery platform in Kuwait and the Gulf, by providing exceptional services and a unique user experience, while maintaining the highest standards of quality and efficiency.",
    our_values: "Our Values",
    value_quality: "Quality",
    value_quality_description: "We are committed to providing high-quality services to all our customers, including restaurants, drivers, and end-users.",
    value_innovation: "Innovation",
    value_innovation_description: "We continuously work on developing and improving our services using the latest technologies and innovative solutions.",
    value_customer: "Customer Satisfaction",
    value_customer_description: "We put our customers' satisfaction at the forefront of our priorities and strive to provide an exceptional experience that meets their expectations.",

    // Contact Us Translations
    contact_form: "Contact Form",
    contact_info: "Contact Information",
    send_message: "Send Message",
    name: "Name",
    subject: "Subject",
    message: "Message",
    address: "ATDelivery Tower, Salem Al Mubarak St, Salmiya, Kuwait",
    phone: "+965 5555 5555",
    contact_email: "info@atdelivery.net",
    working_hours: "Working Hours",
    working_hours_description: "We are available from 9 AM to 10 PM, 7 days a week",
    social_media: "Social Media",
    driver_support: "Driver Support",
    driver_hotline: "+965 5555 1111",
    driver_email: "drivers@atdelivery.net",
    emergency_chat_notice: "For urgent assistance, please use the \"Emergency Chat\" feature within the app",
    fill_all_fields: 'Please fill in all required fields',
    restaurant_id: 'Restaurant ID',
    customer_name: 'Customer Name',
    customer_phone: 'Customer Phone',
    customer_address: 'Customer Address',
    order_amount: 'Order Amount',
    cash: 'Cash',
    knet: 'KNet',
    card: 'Card',
    add_order: 'Add Order',
    order_number: 'Order Number',
    actions: 'Actions',
    status_pending: 'Pending',
    status_on_way: 'On the Way',
    status_delivered: 'Delivered',
    status_cancelled: 'Cancelled',
    restaurant_management: 'Restaurant Management',
    add_new_restaurant: 'Add New Restaurant',
    restaurant_name: 'Restaurant Name',
    restaurant_email: 'Email',
    restaurant_phone: 'Phone',
    restaurant_password: 'Password',
    restaurant_area: 'Area',
    restaurant_status: 'Status',
    restaurant_balance: 'Balance',
    restaurants_list: 'Restaurants List',
    add_restaurant: 'Add Restaurant',
    fill_required_fields: 'Please fill in all required fields',
    restaurant_added_success: 'Restaurant added successfully',
    error_adding_restaurant: 'Error adding restaurant',
    status_active: 'Active',
    status_inactive: 'Inactive',
    area_capital: 'Capital',
    area_hawally: 'Hawally',
    area_farwaniya: 'Farwaniya',
    area_ahmadi: 'Ahmadi',
    area_mubarak: 'Mubarak Al-Kabeer',
    area_jahra: 'Jahra',

    // Restaurant Management Translations
    restaurant_management_title: "Restaurant Management",
    restaurant_management_map: "Map",
    restaurant_management_add: "Add Restaurant",
    restaurant_management_stats: "Restaurant Statistics",
    restaurant_management_total: "Total Restaurants",
    restaurant_management_active: "Active Restaurants",
    restaurant_management_total_balance: "Total Balance",
    restaurant_management_no_restaurants: "No restaurants available",
    restaurant_management_name: "Name",
    restaurant_management_phone: "Phone",
    restaurant_management_status: "Status",
    restaurant_management_area: "Area",
    restaurant_management_balance: "Balance",
    restaurant_management_actions: "Actions",
    restaurant_management_edit: "Edit",
    restaurant_management_save: "Save",
    restaurant_management_charge: "Charge 10 KWD",
    restaurant_management_toggle: "Toggle Status",
    restaurant_management_delete: "Delete",
    restaurant_management_add_new: "Add New Restaurant",
    restaurant_management_restaurant_name: "Restaurant Name",
    restaurant_management_email: "Email",
    restaurant_management_phone_number: "Phone Number",
    restaurant_management_password: "Password",
    restaurant_management_initial_balance: "Initial Balance",
    restaurant_management_address: "Address",
    restaurant_management_selected_address: "Selected Address",
    restaurant_management_map_location: "Restaurant Location on Map",
    restaurant_management_search_placeholder: "Search for address in Kuwait",
    restaurant_management_searching: "Searching...",
    restaurant_management_confirm_delete: "Are you sure you want to delete this restaurant?",
    restaurant_management_delete_success: "Restaurant deleted successfully",
    restaurant_management_delete_error: "Error deleting restaurant",
    restaurant_management_balance_error: "Balance cannot be negative",
    restaurant_management_balance_success: "Balance updated successfully",
    restaurant_management_balance_update_error: "Error updating balance",
    restaurant_management_status_success: "Restaurant status updated successfully",
    restaurant_management_status_error: "Error updating restaurant status",
    restaurant_management_map_error: "Error loading map",
    restaurant_management_map_loading: "Loading map...",

    // Orders Page Translations
    orders_title: "Orders",
    orders_new: "New Order",
    orders_restaurant_id: "Restaurant ID",
    orders_customer_name: "Customer Name",
    orders_customer_phone: "Customer Phone",
    orders_customer_address: "Customer Address",
    orders_amount: "Amount",
    orders_payment_method: "Payment Method",
    orders_add: "Add Order",
    orders_number: "Order Number",
    orders_status: "Status",
    orders_actions: "Actions",
    orders_pending: "Pending",
    orders_on_way: "On the Way",
    orders_delivered: "Delivered",
    orders_cancelled: "Cancelled",
    orders_cash: "Cash",
    orders_knet: "KNet",
    orders_card: "Card",
    orders_fill_fields: "Please fill in all required fields",
    orders_add_success: "Order added successfully",
    orders_add_error: "Error adding order",
    orders_update_success: "Order status updated successfully",
    orders_update_error: "Error updating order status",
    orders_db_status: "Database Connection Status",
    orders_db_connected: "Connected to database",
    orders_db_checking: "Checking connection...",
    orders_db_error: "Database connection failed",
    orders_loading: "Loading orders...",
    orders_no_orders: "No orders available",
    orders_fetch_error: "Error fetching orders",

    // Driver Tracking Reports Translations
    driver_tracking_reports: "Driver Tracking Reports",
    activity_report: "Activity Report",
    movements_report: "Movements Report",
    availability_report: "Availability Report",
    activity_app_open: "App Open",
    activity_app_close: "App Close",
    activity_available_toggle: "Availability Toggle",
    activity_order_received: "Order Received",
    activity_order_completed: "Order Completed",
    activity_login: "Login",
    activity_logout: "Logout",
    activity_navigate_to_restaurant: "Navigate to Restaurant",
    activity_navigate_to_customer: "Navigate to Customer",
    activity_order_status_change: "Order Status Change",
    export_excel: "Export Excel",
    export_pdf: "Export PDF",
    report_type: "Report Type",
    date_range: "Date Range",
    all_drivers: "All Drivers",
    page_size: "Page Size",
    total_drivers: "Total Drivers",
    active_drivers: "Active Drivers",
    average_active_time: "Average Active Time",
    average_speed: "Average Speed",
    total_available_time: "Total Available Time",
    km_per_hour: "km/h",
    hours: "hours",
    app_open: "App Open",
    available: "Available",
    available_time: "Available Time",
    unavailable_time: "Unavailable Time",
    max_speed: "Max Speed (km/h)",
    activity_details: "Driver Activity Details",
    movements_details: "Driver Movements Details",
    availability_details: "Driver Availability Details",
    time: "Time",
    activity_type: "Activity Type",
    value: "Value",
    no_data_for_period_or_filter: "No data for the selected period or filter",
    yes: "Yes",
    no: "No",
    loading_more_data: "Loading more data...",
    load_more_data: "Load more data",
    all_data_displayed: "All available data displayed",
    location: "Location (Lat/Lng)",
    speed: "Speed (km/h)",
    destination: "Destination",
    no_data_for_period: "No data for the selected period",
    not_available: "Not available",
    notes: "Notes",
    all_statuses: "All Statuses",
    orders_management: "Orders Management",
    orders_list: "Orders List",
    orders_map: "Orders Map",
    all_restaurants: "All Restaurants",
    table: "Table",
    cards: "Cards",
    details: "Details",
    track: "Track",
    delete_selected_orders: "Delete Selected Orders",
    delete_confirmation: "Delete Confirmation",
    confirm_delete_message: "Are you sure you want to delete the selected orders?",
    permanent_delete_warning: "Warning: Orders will be permanently deleted from the database and restaurant data!",
    confirm_delete: "Confirm Delete",
    no_orders_found: "No orders match the selected filters",
    delivered: "Delivered",
    picked_up: "Picked Up",
    pending: "Pending",
    loading_map: "Loading map...",
    restaurant_and_delivery: "Restaurant & Delivery Info",
    unknown_restaurant: "Unknown",
    no_driver_assigned: "No driver assigned",
    unknown_amount: "Unknown",
    unknown_delivery_fee: "Unknown",
    delete_order: "Delete Order",
    order_search_placeholder: "Order number, customer name, phone number",
    chat_messages: "Chat Messages",
    mark_all_as_read: "Mark All as Read",
    mark_as_read: "Mark as Read",
    no_notifications: "No notifications",
    in_this_category: "in this category",
    all: "All",
    unread: "Unread",
    read: "Read",
    order_completed: "Order Completed",
    average_delivery_time: "Average Delivery Time",
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const savedLang = localStorage.getItem("language");
    return savedLang || "ar";
  });

  useEffect(() => {
    document.documentElement.dir = language === "ar" ? "rtl" : "ltr"; // ✅ تصحيح الاتجاه
    document.documentElement.lang = language;
    localStorage.setItem("language", language);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage((prevLang) => (prevLang === "ar" ? "en" : "ar"));
  };

  const t = (key) => {
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
